import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../../design-system/modal/modal';
import { Stack } from '../../../../design-system/stack/stack';

type AccountMappingExitConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
};

export const AccountMappingExitConfirmationModal = ({
  isOpen,
  onClose,
  onExit,
}: AccountMappingExitConfirmationModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[520px]">
        <VisuallyHidden>
          <ModalTitle>Exit account mapping confirmation</ModalTitle>

          <ModalDescription>Exit account mapping confirmation</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <Stack space={10} align="stretch" className="p-7">
          <Stack space={4} align="stretch">
            <h3 className="text-xl font-medium leading-6 tracking-tight text-black">Are you sure you want to exit?</h3>

            <p className="text-base font-medium leading-6 tracking-tight text-seapoint-gray-text">
              Without completing your account mapping, we can't automatically push your payments to Xero.
            </p>
          </Stack>

          <Inline space={2}>
            <Button variant="default" onClick={onClose} className="flex-1">
              Finish setup
            </Button>

            <Button variant="destructive" onClick={onExit} className="flex-1">
              Exit anyway
            </Button>
          </Inline>
        </Stack>
      </ModalContent>
    </Modal>
  );
};
